import * as React from 'react'

import { connect } from 'react-redux'
import { bindActionCreators, compose } from 'redux'

import { addFullstory } from './services/fullstory'
import { addGtm } from './services/googleAnalytics'
import { addHotjar } from './services/hotjar'
import { addRollbar } from './services/rollbar'
import { userLeapInit } from './services/userLeap'

import Routes from './routes'

import { versionUpdated } from './services/app'
import * as ConfigActions from './store/configs/actions'
import * as FormsActions from './store/forms/actions'

import { ChildListenerProvider } from 'components/ChildListener'

// import SnackbarService from './services/snackbars'

import {
  IOnlineProps,
  Snackbars,
  withAuthentication,
  withMixpanelProvider,
  withOnlineDetectProvider,
  withPlusUserListener,
  withPlusUserListenerProvider,
  withUserListener,
  withUserListenerProvider
} from 'components'

import { addSafariDatepickerFix } from 'services/safariDatepickerFix'
import './App.scss'

interface IReduxStateProps {
  userAuth: any
}
interface IReduxDispatchProps {
  FormsLib: any
  ConfigLib: any
}

interface IProps extends IReduxStateProps, IReduxDispatchProps, IOnlineProps {}

interface IState {
  isUserLeapSent: boolean
}

class App extends React.Component<IProps> {
  state: IState = {
    isUserLeapSent: false
  }
  componentDidMount() {
    const { FormsLib, ConfigLib } = this.props
    if (versionUpdated()) {
      FormsLib.clear()
      ConfigLib.setVersion(process.env.REACT_APP_VERSION)
    }
    addSafariDatepickerFix()
    addFullstory()
    addHotjar()
    addRollbar()
    addGtm()
    userLeapInit(document, 'https://cdn.userleap.com/shim.js', 'gmfrNOX_S')

    this.sendUserLeap()
  }

  componentDidUpdate() {
    const { isUserLeapSent } = this.state
    if (!isUserLeapSent) {
      this.sendUserLeap()
    }
  }

  public render() {
    return (
      <div className="App">
        <ChildListenerProvider>
          <Routes />
        </ChildListenerProvider>
        <Snackbars />
      </div>
    )
  }

  private sendUserLeap() {
    const { userAuth } = this.props
    if (userAuth) {
      // Ensures UserLeap does not re-survey the same user and increases tracking accuracy
      window.UserLeap('setUserId', userAuth.uid)
      // Sets visitor's email address to enable email surveys
      window.UserLeap('setEmail', userAuth.email)
      this.setState({ isUserLeapSent: true })
    }
  }
}

const mapStateToProps = (state): IReduxStateProps => ({
  userAuth: state.user.auth
})

const mapDispatchToProps = (dispatch): IReduxDispatchProps => ({
  FormsLib: bindActionCreators(FormsActions, dispatch),
  ConfigLib: bindActionCreators(ConfigActions, dispatch)
})

const connector = connect(mapStateToProps, mapDispatchToProps)

export default compose(
  withAuthentication,
  withMixpanelProvider,
  withOnlineDetectProvider,
  withUserListenerProvider,
  withUserListener,
  withPlusUserListenerProvider,
  withPlusUserListener,
  connector
)(App)



// WEBPACK FOOTER //
// ./src/App.tsx